import ResponsiveHelper from "../utils/ResponsiveHelper";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import SliderModule from "../components/Slider";

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin)

export default class Archive {
    constructor(dom) {
        this.dom = dom;
        window.addEventListener("resize", () => this.resize());
    }
    init() {
        this.initResponsiveHelper();
        this.initFilter()
        this.initMobileFilter();
    }

    initResponsiveHelper() {
        this.rHelper = new ResponsiveHelper();
        window.addEventListener("onBreakpointChange", (e) => {
        //console.log(e.detail);
        });
    }

    initFilter() {
        const filterForm = this.dom.querySelectorAll("[js-filter-form]");
        filterForm.forEach((form) => {
            const yearFilter = form.querySelector("[js-filter-year]");
            form.addEventListener("change", () => {
                const selectedYear = yearFilter.value;
                console.log("Selected year:", selectedYear);

                
                // then add attr selected and remove other
                const yearSections = this.dom.querySelectorAll(".year-section");
                yearSections.forEach((section) => {
                    if (section.id === selectedYear) {

                        // copy section and delete old section
                        const newSection = section.cloneNode(true);
                        section.parentNode.replaceChild(newSection, section);
                        newSection.setAttribute("selected", "true");

                        // section.setAttribute("selected", "true");
                        // section.scrollIntoView({
                        //     behavior: "smooth",
                        //     block: "start",
                        // });
                        newSection.style.display = "block";
                        newSection.querySelectorAll("[js-scroll_fadein='batch']").forEach((el) => {
                            el.removeAttribute("style");
                        });
                        ScrollTrigger.batch(newSection.querySelectorAll("[js-scroll_fadein='batch']"), {
                            start: "top 90%",
                            invalidateOnRefresh: true,
                            // markers: true,
                            onEnter: (elements, triggers) => {
                            gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
                            // console.log(elements.length, "elements entered");
                            },
                            onLeaveBack: (elements, triggers) => {
                            // gsap.to(elements, { opacity: 0, y: 40, stagger: 0.15 });
                            // console.log(elements.length, "elements leave back");
                            },
                        });
                        const sliderWrapper = newSection.querySelectorAll(".slider-section");
                        
                        sliderWrapper.forEach((slider) => {
                            new SliderModule(slider);
                        });
                        // ScrollTrigger.getById(section.id)?.enable();
                    } else {
                        section.removeAttribute("selected");
                        section.style.display = "none";
                        // disable all [js-scroll_fadein] scroll trigger for this section
                        // ScrollTrigger.getById(section.id)?.disable();

                    }
                });

                gsap.to(window, { duration: .5,
                    scrollTo: {
                        y: 0,
                        // offsetY: document.querySelector('header').offsetHeight
                    }
                });

                // Refresh ScrollTrigger and do enter animations
                ScrollTrigger.refresh();

                // sync all form
                filterForm.forEach((f) => {
                    if (f !== form) {
                        const yearInput = f.querySelector("[js-filter-year]");
                        yearInput.value = selectedYear;
                    }
                });
            });
        });

    }

    initMobileFilter() {
        const filterYearWrap = this.dom.querySelector("[js-m-filter]");
        const secH = this.dom.querySelector(".archive-page__intro").clientHeight;
        
        if (filterYearWrap) {
            filterYearWrap.hidden = true;
            window.addEventListener("scroll", () => {
                let currTop = window.scrollY;
                // console.log(secH, currTop, filterYearWrap.hidden);
                if (currTop >= secH && filterYearWrap.hidden == true) {
                    filterYearWrap.classList.add("show");
                    filterYearWrap.hidden = false;
                } else if (currTop < secH && filterYearWrap.hidden == false) {
                    filterYearWrap.classList.remove("show");
                    filterYearWrap.hidden = true;
                }
            });


        }
        
        // console.log(secH);

        
    }
    resize() {
        // console.log("resize from Homepage.js");
    }
}
